import React, { Fragment } from 'react'
import cx from 'classnames'
import { injectIntl } from 'sb-react-intl'
import { useCallback } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import actions from 'redux/actions'
import { constants, snowplow } from 'common/helpers'

import { ReactComponent as Icon } from 'components/_new/ui/Icon/images/nav/profile.svg'
import Image from 'components/_new/ui/Image/Image'

import SidebarProfileNav from './SidebarProfileNav/SidebarProfileNav'

import messages from './messages'
import s from './ProfileButton.scss'


const ProfileButton = ({ intl, className, onOpen }) => {
  const { isOpened, avatarImage } = useConnect({
    isOpened: 'models.ui.isProfileMenuVisible',
    avatarImage: 'models.me.avatar',
  })

  const handleClick = useCallback(() => {
    if (isOpened) {
      actions.models.ui.closeProfileMenu()
      return
    }

    actions.models.ui.openProfileMenu()
    snowplow.track(constants.snowplowEvents.profileMenuClick, {}, true)

    if (typeof onOpen === 'function') {
      onOpen('profile')
    }
  }, [ isOpened, onOpen ])

  return (
    <Fragment>
      <button
        className={cx(s.button, className)}
        type="button"
        aria-label={intl.formatMessage(messages.profileMenu)}
        onClick={handleClick}
      >
        {
          avatarImage ? (
            <Image className={s.avatar} src={avatarImage} w={50} x2 x3 />
          ) : (
            <Icon />
          )
        }
      </button>
      <SidebarProfileNav />
    </Fragment>
  )
}


export default injectIntl(ProfileButton)
